// import { createApp } from 'vue'
// import App from './App.vue'

// createApp(App).mount('#app')


import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // ✅ import your router instance
// Bootstrap CSS is loaded via <link id="bootswatch-theme"> in public/index.html
// so we can swap themes at runtime without a page reload.
// DO NOT import bootswatch CSS here — it would be bundled and override the CDN link.
import './assets/tables.css'
// import 'bootstrap' // optional JS (for dropdowns, modals, etc.)
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import am from './locales/am.json'


const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('app_locale') || 'en',
  fallbackLocale: 'en',
  messages: { en, am },
})

// ── Apply saved theme before mount (no flash on reload) ──────────────
const savedTheme = localStorage.getItem('app_theme') || 'cerulean'
const themeLink = document.getElementById('bootswatch-theme')
if (themeLink) {
  themeLink.href = `https://cdn.jsdelivr.net/npm/bootswatch@5/dist/${savedTheme}/bootstrap.min.css`
}

const app = createApp(App)


app.use(router) // ✅ tell Vue to use the router
app.use(i18n) // ✅ translate
app.mount('#app')
